import * as React from "react";
const SvgSignalCellularConnectedNoInternet4BarOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z" />
  </svg>
);
export default SvgSignalCellularConnectedNoInternet4BarOutlined;
